import { DisplayItem } from 'design-system';

const booleanRadioData: DisplayItem[] = [
  { Value: 'yes', Text: 'Sí' },
  { Value: 'no', Text: 'No' },
];
export default booleanRadioData;
